<template>
  <!-- Check that the SDK client is not currently loading before accessing is methods -->
  <nav v-if="!$auth.loading" class="navbar" role="navigation" aria-label="main navigation">
    <div class="navbar-brand">
      <a class="navbar-item" href="https://upperfield.me">
        <img src="../assets/upperfield.png" width="102" height="58" />
      </a>

      <a
        role="button"
        class="navbar-burger burger"
        aria-label="menu"
        aria-expanded="false"
        data-target="navbarBasicExample"
      >
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
      </a>
    </div>

    <div id="navbarBasicExample" class="navbar-menu">
      <div class="navbar-start">
        <router-link class="navbar-item" v-if="$auth.isAuthenticated" to="/">Home</router-link>

        <!-- NEW - add a route to the profile page -->
        <router-link class="navbar-item" v-if="$auth.isAuthenticated" to="/profile">Profile</router-link>

        <div class="navbar-item has-dropdown is-hoverable">
          <a class="navbar-link">More</a>

          <div class="navbar-dropdown">
            <a class="navbar-item">About</a>
            <!-- NEW - add a route to the profile page -->
            <router-link class="navbar-item" to="/admin">Admin</router-link>
            <!-- NEW - add a route to the profile page -->
            <router-link class="navbar-item" to="/external-api">External Api</router-link>
            <hr class="navbar-divider" />
            <a class="navbar-item">Report an issue</a>
          </div>
        </div>
      </div>

      <div class="navbar-end">
        <div class="navbar-item">
          <div class="buttons">
            <a class="button is-primary" v-if="!$auth.isAuthenticated">
              <strong>Sign up</strong>
            </a>
            <!-- show login when not authenticated -->
            <a class="button is-light" v-if="!$auth.isAuthenticated" @click="login">Log in</a>
            <!-- show logout when authenticated -->
            <a class="button is-light" v-if="$auth.isAuthenticated" @click="logout">Log out</a>
          </div>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
export default {
  name: "MainHeader",
  data() {
    return {};
  },
  methods: {
    login() {
      this.$auth.loginWithRedirect();
    },
    logout() {
      this.$auth.logout({
        returnTo: window.location.origin,
      });
    },
  },
};
</script>